export const ActionType = {
  SET_ALL_JOBS: 'SET_ALL_JOBS',
  SET_SELECTED_JOB: 'SET_SELECTED_JOB_PREFERENCES',
  SET_NEW_JOB: 'SET_NEW_JOB',
  SET_JOB_LIST: 'SET_JOB_LIST',
  SET_JOB_LIST_STARTED: 'SET_JOB_LIST_STARTED',
  SET_JOB_LIST_COMPLETED: 'SET_JOB_LIST_COMPLETED',
};
